import { MatFabMenu } from "@angular-material-extensions/fab-menu";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

@Component({
    selector: "app-fixed-button",
    templateUrl: "./fixed-button.component.html",
    styleUrls: ["./fixed-button.component.scss"]
})
export class FixedButtonComponent implements OnInit {
    @Input("action-description")
    public actionDescription!: string;

    @Input("icon")
    public icon!: string;

    @Input("action-icon")
    public actionIcon!: string;

    @Input("route")
    public route!: any[];

    @Input("menu")
    public menu: MatFabMenu[];

    @Output("click")
    public click: EventEmitter<any> = new EventEmitter<any>();

    @Output("subMenuClick")
    public subMenuClick: EventEmitter<any> = new EventEmitter<any>();

    constructor() {}

    ngOnInit() {}

    public emitClick(event: any) {
        this.click.emit(event);
    }

    public subMenuClicked(event: number): void {
        this.subMenuClick.emit(event);
    }
}
